// The root graphql field name for the app prismic schema.
exports.fieldName = 'appPrismic';
exports.typeName = 'DOUGHAPP';
